import React from 'react';
import BaseTile from 'commonComponents/tiles/BaseTile/BaseTile';
import styles from './HorizontalTiles.module.scss';

const HorizontalTiles = ({ tilesData, additionalClass }) => {
  return ( 
    <div className={ styles.HorizontalTiles }>
      {
        tilesData && tilesData.map((tileContent, i) =>
          <BaseTile
            { ...tileContent }
            key={ i }
            additionalClass={ additionalClass }
          />
        )
      }
    </div>
  );
};

export default HorizontalTiles;
